// https://reacttraining.com/react-router/web/api/Router
// https://stackoverflow.com/questions/44153517/how-to-access-history-object-outside-of-a-react-component
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
